import React, { Component, Fragment } from 'react'
import { isEqual, without } from 'underscore'
export default class Select extends Component {
  constructor(props) {
    super(props)

    this.state = {
      values: this.checkedValues(props)
    }    
  }

  // which values are currently checked:
  checkedValues = props => {
    return props.children
    .reduce(
      (collect, child) =>
        child.props.checked ? [...collect, child.props.value] : collect,
      []
    )
    .sort()
  }    

  componentWillUpdate(props) {
    const checkedValues = this.checkedValues(props)
    if (isEqual(checkedValues, this.state)) {
      this.setState({
        values: this.checkedValues(props)
      })
    }
  }

  toggleValue = value => {
    const { values: checkedValues } = this.state
    const values = !checkedValues.includes(value)
      ? [...checkedValues, value]
      : checkedValues.filter(includedValue => includedValue !== value)
    this.setState({ values })
    this.props.onChange(values)
  }

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        onChange: () => this.toggleValue(child.props.value)
      })
    })
    return <Fragment>{children}</Fragment>
  }
}
